// Import components
import './footer';
import './settings';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish' )
export class AutomatorBuilderPublish extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="publish">
				${ this._templateSettings }
				${ this._templateFooter }
			</div>
		`;
	}

	/**
	 * The settings of the recipe
	 *
	 * @return {TemplateResult} The settings of the recipe
	 */
	get _templateSettings() {
		return html`
			<div class="publish-settings">
				<uap-builder-publish-settings></uap-builder-publish-settings>
			</div>
		`;
	}

	/**
	 * The footer of the publish metabox. Contains the toggle to set the recipe live.
	 *
	 * @return {TemplateResult} The footer
	 */
	get _templateFooter() {
		return html`
			<div class="publish-footer">
				<uap-builder-publish-footer></uap-builder-publish-footer>
			</div>
		`;
	}
}